import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  // ── Operator select and value input ───────────────────────────────────────
  operatorSelect: {
    width: '100%'
  },
  valueInput: {
    flex: 1,
    width: '100%'
  },

  // ── Panel ─────────────────────────────────────────────────────────────────
  panel: {
    padding: '16px',
    width: '340px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    maxHeight: '550px'
  },
  sectionLabel: {
    marginBottom: '4px',
    display: 'block',
    fontWeight: 'bold'
  },

  // ── Input rows ────────────────────────────────────────────────────────────
  inlineLabel: {
    color: 'text.secondary'
  },
  operatorRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '4px'
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    marginTop: '6px',
    marginBottom: '8px'
  },
  inputWithButton: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  addButton: {
    flexShrink: 0
  },
  radioGroup: {
    gap: '0px'
  },
  radioButton: {
    padding: '0px',
    marginTop: '4px'
  },
  radioFormLabel: {
    marginLeft: '0px',
    marginRight: '16px',
    '&.MuiFormControlLabel-root:has(.MuiRadio-root)': {
      alignItems: 'center',
      marginRight: '8px'
    }
  },

  // ── Checkbox list ─────────────────────────────────────────────────────────
  panelBody: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '12px'
  },
  checkboxList: {
    flexShrink: 0,
    height: '146px',
    minHeight: '146px',
    overflowY: 'auto',
    overflowX: 'hidden',
    marginY: '8px',
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'divider'
  },
  checkboxCenteredContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%'
  },
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minWidth: 0
  },
  formControlLabel: {
    marginLeft: '0px',
    minWidth: 0,
    marginRight: '4px',
    marginY: '0px',
    '& .MuiFormControlLabel-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },
  checkbox: {
    padding: '1px'
  },
  valueCount: {
    flexShrink: 0,
    paddingRight: '8px',
    alignSelf: 'center'
  },
  noMatchesText: {
    color: 'text.secondary'
  },

  // ── Logic section ─────────────────────────────────────────────────────────
  logicSection: {
    flexShrink: 0,
    marginTop: '4px',
    marginBottom: '4px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },

  // ── Added conditions ──────────────────────────────────────────────────────
  addedSection: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '8px'
  },
  conditionList: {
    maxHeight: '102px',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
    alignContent: 'flex-start',
    marginY: '8px',
    paddingTop: '8px',
    paddingBottom: '8px',
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: 'divider',
    flex: 1
  },
  conditionRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    maxWidth: '100%'
  },
  conditionPrefix: {
    whiteSpace: 'nowrap',
    flexShrink: 0
  },
  conditionChip: {
    minWidth: 0,
    '& .MuiChip-label': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  },

  // ── Visually hidden (screen-reader only) ─────────────────────────────────
  visuallyHidden: {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0px',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: '0px'
  },

  // ── Footer ────────────────────────────────────────────────────────────────
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '4px',
    marginTop: '8px',
    flexShrink: 0
  }
});
